import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  MyAdvertisements: [],
};

const AdvertisementReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_MY_ADVERTISEMENTS:
      let data = action.payload;
      console.log("deleted", state.MyAdvertisements);
      state = {
        ...state,
        MyAdvertisements: data,
      };
      break;
    case ActionTypes.DELETE_ADVERTISEMENT:
      let deleted = action.payload;
      let copyData = [...state.MyAdvertisements];
      copyData.splice(deleted, 1);
      state = { ...state, MyAdvertisements: copyData };
      break;
    case ActionTypes.CLEAR_ADVERTISEMENTS:
      state = { ...state, MyAdvertisements: [] };
      break;

    default:
      break;
  }
  return state;
};
export default AdvertisementReducer;
